import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FranchiseMetaTags from "./component";
import { withRouter } from "react-router";

const mapStateToProps = ({
    meta: { seo }
}) => ({
    seo
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FranchiseMetaTags));
